// Shared cookie-consent constants. Kept in one place so the banner
// (CookieConsentBanner.vue) and the login flow (pages/auth/login) agree on the
// localStorage key used to persist and forward the device pseudonym. See AL-549.
export const CONSENT_ANON_KEY = 'ibjjf_consent_anonymous_id'
